export interface BaseStationStep {
  name: string;
  index: number;
  status: 'PENDING' | 'STARTED' | 'IN_PROGRESS' | 'COMPLETED' | 'FAILED';
  comment?: string;
  displayData?: { [key: string]: any };
}

export type CalibrationStatus =
  | 'PENDING'
  | 'STARTED'
  | 'IN_PROGRESS'
  | 'COMPLETED'
  | 'FAILED';

export interface CalibrationResponse {
  status: string;
  s?: string;
  response?: {
    StepCompletionStatus: string;
    Comments?: string;
  };
  error_message?: string;
}

export const BASE_STATION_STEPS: BaseStationStep[] = [
  { name: 'Initial Connection Test', status: 'PENDING', index: 1 },
  { name: 'Configure Rover Mode', status: 'PENDING', index: 2 },
  { name: 'Configure Communication Ports', status: 'PENDING', index: 3 },
  { name: 'Enable NAV-PVT Messages', status: 'PENDING', index: 4 },
  { name: 'Enable NAV-POSECEF Messages', status: 'PENDING', index: 5 },
  { name: 'Check Base Station Coordinates', status: 'PENDING', index: 6 },
  { name: 'Get Nearest NTRIP Stations', status: 'PENDING', index: 7 },
  { name: 'Forward RTCM Data', status: 'PENDING', index: 8 },
  { name: 'Check RTK Fix', status: 'PENDING', index: 9 },
  { name: 'Collect ECEF Position Data', status: 'PENDING', index: 10 },
  { name: 'Enable RTCM Messages', status: 'PENDING', index: 11 },
  { name: 'Configure Fixed Mode', status: 'PENDING', index: 12 },
];
